// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getPortalRoot = (type: string = "portal") => typeof window !== "undefined" && (document.getElementById(`${type}-root`) ?? document.body);

export default getPortalRoot;
